import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useFormik, getIn } from "formik";
import * as Yup from "yup";
import CONSTANTS, {
  PRODUCT_CATEGORY_FORM_ID,
  PRODUCT_CODES_FORM_ID,
  Product_Code_Form_Constants,
} from "../../constants/constants";
import {
  fetchRuntimeFormData,
  postRuntimeFormData,
} from "../../services/FormService";
import {
  Autocomplete,
  Box,
  FormHelperText,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import { pushNotification } from "../../redux/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  productCategoryFormContainer: {
    width: "100%",
  },

  formSection: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 10,
    gap: 15,
  },
  btnSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 10,
    gap: 20,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },
  fieldLabel: {},
  fieldinput: {
    minWidth: "240px !important",
  },
  discriptionInput: {
    minWidth: "480px !important",
  },
}));

const CreateProductCategory = (props) => {
  const { data, setOpen, setRefresh } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [initalStateValues, setInitalStateValues] = useState({
    productCategory: data?.productCategory || "",
  });

  const formOne = useFormik({
    initialValues: initalStateValues,
    validationSchema: Yup.object({
      productCategory: Yup.string().required(
        Product_Code_Form_Constants.productCategory
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleFinalSubmit(values, setSubmitting);
    },
    enableReinitialize: true,
  });

  const handleFinalSubmit = async (values: any, setSubmitting: any) => {
    setSubmitting(true);
    handleFormSubmit();
  };

  const handleFormSubmit = async () => {
    if (data?.id) {
      const body = {
        formId: PRODUCT_CATEGORY_FORM_ID,
        id: data?.id,
        formData: {
          productCategory: formOne.values.productCategory,
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpen(false);
        setRefresh((prevState) => !prevState);
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        setOpen(false);
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
      }
    } else {
      const body = {
        formId: PRODUCT_CATEGORY_FORM_ID,
        formData: {
          productCategory: formOne.values.productCategory,
        },
      };
      const response: any = await postRuntimeFormData(body);
      if (response?.success) {
        setOpen(false);
        setRefresh((prevState) => !prevState);
        dispatch(
          pushNotification({
            isOpen: true,
            type: CONSTANTS.SUCCESS,
            message: response?.message,
          })
        );
      } else {
        setOpen(false);
        pushNotification({
          isOpen: true,
          type: CONSTANTS.ERROR,
          message: response?.message,
        });
      }
    }
  };

  return (
    <div className={classes.productCategoryFormContainer}>
      <div className={classes.formSection}>
        <Box display={"flex"} flexDirection={"column"}>
          <label className={classes.fieldLabel}>Product Category</label>
          <TextField
            className={classes.fieldinput}
            id="product-category"
            name="productCategory"
            size="small"
            onBlur={formOne.handleBlur}
            onChange={formOne.handleChange}
            value={formOne.values.productCategory}
            helperText={
              formOne.touched.productCategory && formOne.errors.productCategory
            }
            error={
              formOne.touched.productCategory &&
              Boolean(formOne.errors.productCategory)
            }
          />
        </Box>
      </div>
      <div className={classes.btnSection}>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => formOne.submitForm()}
        >
          Submit
        </Button>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => setOpen(false)}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default CreateProductCategory;
